module.exports = ".pharma-radio {\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n\n.pharma-radio input[type='radio'] {\n    margin-left: 20px;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/add-campaign/add-campaign.component.css
// module id = ./src/app/add-campaign/add-campaign.component.css
// module chunks = main